import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';

import { S1Module  } from '../s1/s1.module';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { FlotDirective } from './directives/flot/flot.directive';
import { SparklineDirective } from './directives/sparkline/sparkline.directive';
import { ColorsService } from './colors/colors.service';
import { CheckallDirective } from './directives/checkall/checkall.directive';
import { VectormapDirective } from './directives/vectormap/vectormap.directive';
import { NowDirective } from './directives/now/now.directive';
import { ScrollableDirective } from './directives/scrollable/scrollable.directive';
import { FormHeaderComponent } from './components/form-header/form-header.component';
import { ElementBoxComponent } from './components/element-box/element-box.component';
import { ElementTypeTextComponent } from './components/elements/element-type-text/element-type-text.component';
import { ElementTypeDateComponent } from './components/elements/element-type-date/element-type-date.component';
import { ElementTypeSingleCheckComponent } from './components/elements/element-type-single-check/element-type-single-check.component';
import { ElementTypeListCheckComponent } from './components/elements/element-type-list-check/element-type-list-check.component';
import { ElementTypeListRadioComponent } from './components/elements/element-type-list-radio/element-type-list-radio.component';
import { ElementTypeEmailComponent } from './components/elements/element-type-email/element-type-email.component';
import { ElementTypeLinkComponent } from './components/elements/element-type-link/element-type-link.component';
import { ElementTypeNumberComponent } from './components/elements/element-type-number/element-type-number.component';
import { ElementTypeRichtextComponent } from './components/elements/element-type-richtext/element-type-richtext.component';
import { ElementTypeListComponent } from './components/elements/element-type-list/element-type-list.component';
import { ElementTypeEntityComponent } from './components/elements/element-type-entity/element-type-entity.component';

// https://angular.io/styleguide#!#04-10
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        AccordionModule.forRoot(),
        AlertModule.forRoot(),
        ButtonsModule.forRoot(),
        CarouselModule.forRoot(),
        CollapseModule.forRoot(),
        BsDatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        ProgressbarModule.forRoot(),
        RatingModule.forRoot(),
        TabsModule.forRoot(),
        TimepickerModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        TypeaheadModule.forRoot(),
        ToastrModule.forRoot(),
        S1Module.forRoot()
    ],
    providers: [
        ColorsService
    ],
    declarations: [
        FlotDirective,
        SparklineDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        FormHeaderComponent,
        ElementBoxComponent,
        ElementTypeTextComponent,
        ElementTypeDateComponent,
        ElementTypeSingleCheckComponent,
        ElementTypeListCheckComponent,
        ElementTypeListRadioComponent,
        ElementTypeEmailComponent,
        ElementTypeLinkComponent,
        ElementTypeNumberComponent,
        ElementTypeRichtextComponent,
        ElementTypeListComponent,
        ElementTypeEntityComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,
        CarouselModule,
        CollapseModule,
        BsDatepickerModule,
        BsDropdownModule,
        ModalModule,
        PaginationModule,
        ProgressbarModule,
        RatingModule,
        TabsModule,
        TimepickerModule,
        TooltipModule,
        PopoverModule,
        TypeaheadModule,
        ToastrModule,
        FlotDirective,
        SparklineDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        S1Module,
        FormHeaderComponent,
        ElementBoxComponent,
        ElementTypeTextComponent,
        ElementTypeDateComponent,
        ElementTypeSingleCheckComponent,
        ElementTypeListCheckComponent,
        ElementTypeListRadioComponent,
        ElementTypeEmailComponent,
        ElementTypeLinkComponent,
        ElementTypeNumberComponent,
        ElementTypeRichtextComponent,
        ElementTypeListComponent,
        ElementTypeEntityComponent
    ]
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule
        };
    }
}
